import * as React from 'react';

const CustomLinkIcon = ({fillColor = '#2d2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill={fillColor}
        d="M7.038 16.538c-1.255 0-2.325-.442-3.21-1.327-.885-.885-1.328-1.955-1.328-3.21 0-1.256.442-2.326 1.328-3.212.885-.885 1.955-1.328 3.21-1.328h3.02c.212 0 .39.072.534.216a.726.726 0 0 1 .216.535c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.215h-3.02c-.84 0-1.556.297-2.149.89A2.928 2.928 0 0 0 4 12c0 .84.296 1.556.89 2.149.592.593 1.308.89 2.147.89h3.02c.213 0 .391.071.535.215a.726.726 0 0 1 .216.535c0 .212-.072.39-.216.534a.725.725 0 0 1-.534.215h-3.02ZM9 12.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 8.25 12c0-.213.072-.391.216-.534A.725.725 0 0 1 9 11.25h6c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.391-.216.534a.726.726 0 0 1-.534.216H9Zm4.942 3.788a.725.725 0 0 1-.534-.215.726.726 0 0 1-.216-.535c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.215h3.02c.84 0 1.556-.297 2.148-.89.593-.593.89-1.31.89-2.149 0-.84-.297-1.556-.89-2.149a2.926 2.926 0 0 0-2.147-.89h-3.02a.725.725 0 0 1-.535-.215.726.726 0 0 1-.216-.535c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.216h3.02c1.255 0 2.326.443 3.21 1.328.886.885 1.328 1.955 1.328 3.21 0 1.256-.442 2.326-1.328 3.211-.884.886-1.955 1.328-3.21 1.328h-3.02Z"
      />
    </g>
  </svg>
);
export default CustomLinkIcon;
